// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"az_I5","azLogo":"az_J5","azLogoMedium":"az_K5"};